import { render, staticRenderFns } from "./UserNotificationsListView.vue?vue&type=template&id=3068b0f0&scoped=true"
import script from "./UserNotificationsListView.vue?vue&type=script&lang=js"
export * from "./UserNotificationsListView.vue?vue&type=script&lang=js"
import style0 from "./UserNotificationsListView.vue?vue&type=style&index=0&id=3068b0f0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3068b0f0",
  null
  
)

export default component.exports